"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = void 0;
/**
 * Format a number to given format
 *
 * @param num
 * @param toFixed
 * @returns {string}
 */
var formatNumber = function formatNumber(num) {
  var toFixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var nf = new Intl.NumberFormat();
  return nf.format(Number(num).toFixed(toFixed));
};
exports.formatNumber = formatNumber;